<template>
  <div v-loading="loading">
    <div class="body">
      <img :src="user.avatar" class="img">
      <div class="user_info1">
        <span class="tiele">{{ user.nickname }}</span>
        <span class="time">{{ helleText }}</span>
        <!-- <span class="iis" @click="signin"
          :style="{ color: userSign.is_today_singin ? '#9c623c' : '#3c9c8f' }">{{ userSign.is_today_singin ? "已签到" :
          "签到"}}</span> -->
        <Sign/>
        <span class="iis" @click="goNav('/userinfo')">修改个人信息></span>
      </div>
      <div class="user_info2">
        <div class="denji">
          <span class="time2">会员等级：</span>
          <span class="iis">{{ user.levelname }}</span>
        </div>
        <!-- <div class="denji2">
          <span class="time2">会员天数：</span>
          <span class="iis">2645天</span>
        </div> -->
        <div class="denji2">
          <span class="time2">绑定手机：</span>
          <span class="iis">{{ user.mobile || "未绑定" }}</span>
        </div>
        <div class="denji2">
          <span class="time2">绑定邮箱：</span>
          <span class="iis">{{ user.email || "未绑定" }}</span>
        </div>
      </div>
    </div>

    <div class="body2" style="margin-top:10px;">
      <div class="jifen1">
        <span class="time2">{{ user.score || 0 }}</span>
        <span class="iis">积分</span>
      </div>
      <div class="jifen1">
        <span class="time2">{{ user.balance || 0 }}</span>
        <span class="iis">代金券</span>
      </div>
    </div>

    <div class="list-title">产品订单：</div>
    <div class="row_lsit">
      <div class="items" style="margin-right:10px;">
        <img src="@/assets/user_icon1.png">
        <div class="items_body">
          <div class="orde">
            <span>待确认的订单:</span>
            <span>{{orderCount.count0}}</span>
          </div>
          <span class="items_more" @click="$router.push('/myorderlistview?status=0')">查看待确认的订单></span>
        </div>
      </div>
      <div class="items">
        <img src="@/assets/user_icon2.png">
        <div class="items_body">
          <div class="orde">
            <span>待收货的订单:</span>
            <span>{{orderCount.count1}}</span>
          </div>
          <span class="items_more" @click="$router.push('/myorderlistview?status=2')">查看待收货的订单></span>
        </div>
      </div>
    </div>

    <div class="row_lsit">
      <div class="items" style="margin-right:10px;">
        <img src="@/assets/user_icon3.png">
        <div class="items_body">
          <div class="orde">
            <span>待评价的订单:</span>
            <span>{{orderCount.count2}}</span>
          </div>
          <span class="items_more" @click="$router.push('/evaluateorder?status=0')">查看待评价的订单></span>
        </div>
      </div>
      <div class="items">
        <img src="@/assets/user_icon4.png">
        <div class="items_body">
          <div class="orde">
            <span>售后中的订单:</span>
            <span>{{orderCount.count3}}</span>
          </div>
          <span class="items_more" @click="$router.push('/servicelist?status=1')">查看售后中的订单></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Sign from "./componets/Sign.vue";
import bus from "@/components/eventBus.js";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "UserCenter",
  components: {
    Sign
  },
  data() {
    return {
      loading: false,
      helleText: "",
      orderCount: {}
    };
  },
  computed: {
    ...mapGetters(["user", 'base'])
  },
  
  created() {
    this.init()
  },
  beforeMount() { },
  mounted() { },
  methods: {
    ...mapActions(["getUser"]),
    
    async init() {
     
      const hour = new Date().getHours();
      if (hour < 12 && hour > 6) {
        this.helleText = "上午好";
      } else if (hour < 18 && hour > 12) {
        this.helleText = "下午好";
      } else {
        this.helleText = "晚上好";
      }
      this.loading = true;
      this.getOrderCount()
      await this.getUser()
      this.loading = false;
    },
    async getOrderCount() {
      try {
        const res = await this.$api.getOrderCount()
        console.log(res)
        if(res.code == 1){
          this.orderCount = res.data
        }
      } catch (err) {
        console.log(err)
      }
    },
    goNav(path) {
      this.$router.push(path)
    }
  }
};
</script>

<style lang="less" scoped>
.body {
  background: #ffffff;
  width: 100%;
  padding: 30px 20px 30px 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}

.body2 {
  background: #ffffff;
  width: 100%;
  padding: 40px 20px 40px 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
}

.user_info1 {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-content: center;
  flex: 1;
  margin-left: 40px;
}

.user_info2 {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-content: center;
  flex: 0.8;
}

.img {
  width: 120px;
  height: 120px;
  border-radius: 100px;
  margin-left: 50px;
  background: #333333;
}

.tiele {
  font-size: 24px;
  color: #333333;
  line-height: 35px;
}

.time {
  font-size: 14px;
  color: #999999;
  line-height: 25px;
}

.time2 {
  font-size: 14px;
  color: #666666;
  line-height: 25px;
}

.iis {
  cursor: pointer;
  color: #3c9c8f;
  font-size: 14px;
  line-height: 25px;
}

.denji {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  line-height: 25px;
  height: 25px;
}

.denji span:nth-child(odd) {
  color: #666666;
  font-size: 14px;
}

.denji span:nth-child(even) {
  color: #e69f3e;
  font-size: 14px;
}

.denji2 {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  line-height: 25px;
  height: 25px;
}

.denji2 span:nth-child(odd) {
  color: #666666;
  font-size: 14px;
}

.denji2 span:nth-child(even) {
  color: #666666;
  font-size: 14px;
}

.jifen1 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.jifen1 span:nth-child(odd) {
  color: #333333;
  font-size: 36px;
  line-height: 52px;
}

.jifen1 span:nth-child(even) {
  color: #666666;
  font-size: 18px;
  line-height: 26px;
}
.list-title{
  font-size: 18px;
  color: #333333;
  line-height: 26px;
  font-weight: 700;
  margin-top: 20px;
  margin-bottom: 10px;
}
.row_lsit {
  margin-top: 10px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.items {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  background: #ffffff;
  flex: 1;
  padding: 24px 0px 24px 50px;
}

.items img {
  width: 100px;
  height: 100px;
}

.items_body {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  margin-left: 20px;
}

.orde span:nth-child(odd) {
  color: #333333;
  font-size: 20px;
  line-height: 29px;
}

.orde span:nth-child(even) {
  color: #E69F3E;
  font-size: 20px;
  line-height: 29px;
}

.items_more {
  color: #999999;
  font-size: 14px;
  line-height: 20px;
  cursor: pointer;
}
</style>
